<template>
  <div>
    <h2>商品詳細</h2>
    <div v-if="product">
      <img :src="getImageUrl(product.image_url)" :alt="product.name" class="product-image" />
      <h3>{{ product.name }}</h3>
      <p>価格: ¥{{ product.price.toLocaleString() }}</p>
      <p>説明: {{ product.description }}</p>
      <p>残り在庫: {{ product.stock_quantity }}個</p> <!-- stock_quantityを表示 -->
      <button @click="addToCart(product)" :disabled="product.stock_quantity <= 0">カートに追加</button> <!-- 在庫がない場合はボタンを無効化 -->
      <button @click="goBack">戻る</button>
    </div>
    <div v-else>
      <p>商品が見つかりません。</p>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

export default {
  name: 'ProductDetail',
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const product = ref(null);

    const getImageUrl = (imagePath) => {
      return require(`@/assets/images/${imagePath}`);
    };

    const fetchProduct = async (id) => {
      try {
        const response = await fetch(`http://172.16.80.71:5000/api/products/${id}`);
        if (!response.ok) throw new Error('Network response was not ok');
        const data = await response.json();
        product.value = data; // APIから取得した商品データをセット
      } catch (error) {
        console.error('商品取得に失敗:', error);
      }
    };

    const addToCart = (product) => {
  if (product.stock_quantity > 0) {
    store.commit('addToCart', { ...product, quantity: 1 }); // ここも修正
    alert(`${product.name}をカートに追加しました！`); // ユーザーへの通知
  }
};

    onMounted(() => {
      const id = parseInt(route.params.id);
      fetchProduct(id); // 商品情報を取得
    });

    const goBack = () => {
      router.push('/productlist');
    };

    return {
      product,
      goBack,
      getImageUrl,
      addToCart,
    };
  },
};
</script>

<style>
.product-image {
  width: 200px; /* 画像のサイズを調整 */
  height: auto;
  margin-bottom: 10px; /* テキストとの間隔を追加 */
}
</style>